import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { searchInventorys } from "../../../graphql/inventory/custom-queries";
import { barcodeByActiveByValue } from "../../../graphql/queries";
import { accountByActiveByNameDropDown } from "../../../graphql/account/account-queries";
import { Route } from "react-router-dom";
import { useNotify, Title } from "react-admin";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  CircularProgress,
  TextField,
  MenuItem,
  Button,
  InputAdornment,
  IconButton,
  Box,
  Backdrop,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ScannerIcon, SearchIcon, XIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { InventoryStatus } from "../../../utils/constants";
import { InventoryRelocateCard } from "./relocate/InventoryRelocateCard";
import CrewCard from "../../../components/common/CrewCard";
import { InventoryTimeline } from "./timeline/InventoryTimeline";
import { getAisleFullName } from "../../../utils/locationUtils";
import { InventorySearchCard } from "./InventorySearchCard";
import {
  InventorySearchProvider,
  NO_ACCOUNT,
  SELECT_AN_ACCOUNT,
  useInventorySearchContext,
} from "./context";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { RelocateBarcodeScan } from "./relocate/RelocateBarcodeScan";

const useStyles = makeStyles((theme) => ({
  menuSelection: {
    minHeight: "1rem",
  },
  searchButton: {
    marginTop: theme.spacing(0.25),
  },
  backdrop: {
    zIndex: 1001,
  },
}));

const MAX_INVENTORY_LIMIT = 30;

export const InventorySearch = ({ match }) => {
  return (
    <InventorySearchProvider>
      <Title title={<ForceTitle title="Inventory" />} />
      <Route
        path={`/search/relocate/:id`}
        exact
        render={(props) => <InventoryRelocateCard {...props} />}
      />
      <Route
        path={`${match.url}/timeline/:id`}
        render={(props) => <InventoryTimeline {...props} />}
      />
      <Route
        path={`${match.url}`}
        exact
        render={(props) => <InventorySearchContainer {...props} />}
      />
    </InventorySearchProvider>
  );
};

const InventorySearchContainer = ({ match, history }) => {
  const { state, dispatch } = useInventorySearchContext();
  const {
    allAccounts,
    dbInventories,
    searchInventories,
    selectedSearchAisleId,
    searchAisles,
    noSearch,
  } = state;
  const [scanDialogOpen, setScanDialogOpen] = useState(false);
  const [scannedBarcodes, setScannedBarcodes] = useState([]);

  const handleScanButtonClick = () => {
    setScanDialogOpen(true);
  };

  const handleScanClose = () => {
    setScanDialogOpen(false);
  };

  const handleSaveBarcode = (barcodeItems) => {
    const newBarcodes = barcodeItems.map((item) => item.value);
    setScannedBarcodes((prev) => [...new Set([...prev, ...newBarcodes])]);
    dispatch({
      type: "SET_INVENTORY_ITEM_SCANNED_BARCODE",
      payload: newBarcodes,
    });
    setScanDialogOpen(false);
  };

  const { searchTerm, selectedAccount } = useSelector(
    (state) => state.data.searchState,
  );
  const dispatchRa = useDispatch();
  const [narrowSearchMsg, setNarrowSearchMsg] = useState("");
  const [loading, setLoading] = useState();
  const notify = useNotify();
  const classes = useStyles();

  useEffect(() => {
    debugger;
    if (allAccounts?.length === 1) getAccounts();
    if (noSearch) return;
    dispatch({ type: "NO_SEARCH", payload: false });
    return () => dispatch({ type: "CLEAR_SEARCH" });
  }, []);

  const getAccounts = async () => {
    try {
      setLoading(true);
      const response = await API.graphql(
        graphqlOperation(accountByActiveByNameDropDown, {
          reloadYardId: window.appUser?.reloadYardId,
          activeBusinessName: { beginsWith: { active: "true" } },
        }),
      );
      dispatch({
        type: "SET_ALL_ACCOUNTS",
        payload: [
          NO_ACCOUNT,
          ...response.data.accountByActiveByName.items.map((acct) => {
            return { id: acct.id, businessName: acct.businessName };
          }),
        ],
      });
      // if (searchTerm || (selectedAccount.businessName && selectedAccount.businessName !== SELECT_AN_ACCOUNT)) {
      //     debugger;
      //     handleSearch();
      // }
    } catch (err) {
      logError("InventorySearch:InventorySearchCard:getAccounts", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (searchTerm, selectedSearchAisleId) => {
    try {
      let commonInventoryIds = new Set();
      setLoading(true);
      if (scannedBarcodes && scannedBarcodes.length > 0) {
        const barcodeMap =
          await getInventoriesByInventoryItemBarCode(scannedBarcodes);
        const barcodeResults = Object.values(barcodeMap);

        const pairSets = barcodeResults.map(
          (entries) =>
            new Set(entries.map((e) => `${e.inventoryId}|${e.locationId}`)),
        );

        const commonPairs = pairSets.reduce((acc, set) => {
          if (!acc) return set;
          return new Set([...acc].filter((item) => set.has(item)));
        }, null);

        if (!commonPairs || commonPairs.size === 0) {
          return;
        }

        commonInventoryIds = new Set(
          [...commonPairs].map((pair) => {
            const [inventoryId] = pair.split("|");
            return inventoryId;
          }),
        );
      }

      debugger;
      const limit = MAX_INVENTORY_LIMIT;

      const searchInput = {
        sort: { field: "productName", direction: "asc" },
        filter: {
          reloadYardId: { eq: window.appUser.reloadYardId },
          status: { eq: InventoryStatus.STORED },
        },
        limit,
      };

      const andConditions = [];

      if (searchTerm) {
        andConditions.push({
          or: [
            { productCode: { matchPhrasePrefix: `${searchTerm}` } },
            { productCode: { wildcard: `*${searchTerm}*` } },
            { productName: { matchPhrasePrefix: `${searchTerm}` } },
            { productName: { wildcard: `*${searchTerm}*` } },
            { lotNumber: { matchPhrasePrefix: `${searchTerm}` } },
            { lotNumber: { wildcard: `*${searchTerm}*` } },
            { poNumber: { matchPhrasePrefix: `${searchTerm}` } },
            { poNumber: { wildcard: `*${searchTerm}*` } },
            { railCarNumber: { matchPhrasePrefix: `${searchTerm}` } },
            { railCarNumber: { wildcard: `*${searchTerm}*` } },
            { customFields: { matchPhrasePrefix: `${searchTerm}` } },
            { customFields: { wildcard: `*${searchTerm}*` } },
          ],
        });
      }

      if (commonInventoryIds.size > 0) {
        andConditions.push({
          or: [...commonInventoryIds].map((id) => ({ id: { eq: id } })),
        });
      }

      if (andConditions.length > 0) {
        searchInput.filter.and = andConditions;
      }

      if (
        selectedAccount.businessName &&
        selectedAccount.businessName !== SELECT_AN_ACCOUNT
      ) {
        searchInput.filter = {
          ...searchInput.filter,
          accountId: { eq: selectedAccount.id },
        };
      }

      const response = await API.graphql(
        graphqlOperation(searchInventorys, searchInput),
      );
      const data = response.data.searchInventorys.items;

      if (data.length >= limit) {
        setNarrowSearchMsg(`More data available, please narrow your search.`);
        notify("More data available, narrow your search.", "warning");
      } else {
        setNarrowSearchMsg("");
      }
      dispatch({ type: "SET_DB_INVENTORIES", payload: data });
      dispatch({ type: "SET_SEARCH_INVENTORIES", payload: data });

      if (!selectedSearchAisleId) {
        const aisleMap = {};
        for (let inventory of data) {
          inventory.inventoryItems.items
            .filter(
              (itm) =>
                itm.status === InventoryStatus.STORED ||
                itm.status === InventoryStatus.AGGREGATED,
            )
            .forEach((itm) => {
              if (itm.location) {
                const aisle = itm.location.aisle;
                aisle.area = itm.location.area;
                aisle.zone = itm.location.zone;
                aisleMap[aisle.id] = aisle;
              }
            });
        }
        const aisles = Object.values(aisleMap);
        aisles.sort((a, b) => {
          const aName = getAisleFullName(a);
          const bName = getAisleFullName(b);
          return aName.localeCompare(bName);
        });
        dispatch({
          type: "SET_SEARCH_AISLES",
          payload: [{ id: "", value: "" }, ...aisles],
        });
      } else {
        handleAisleChange(selectedSearchAisleId);
      }
    } catch (err) {
      logError("InventorySearch:handleSearch", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const getInventoriesByInventoryItemBarCode = async (barcodes) => {
    try {
      const allResults = {};

      for (const barcode of barcodes) {
        const searchInput = {
          reloadYardId: window.appUser.reloadYardId,
          activeValue: {
            eq: {
              active: "true",
              value: barcode.value,
            },
          },
          limit: 1000,
        };

        const response = await API.graphql(
          graphqlOperation(barcodeByActiveByValue, searchInput),
        );
        const items = response.data.barcodeByActiveByValue.items;

        allResults[barcode.value] = items.map((item) => ({
          inventoryId: item.inventoryId,
          locationId: item.locationId,
        }));
      }

      return allResults;
    } catch (err) {
      logError(
        "InventorySearch:getInventoriesByInventoryItemBarCode",
        err,
        notify,
      );
      return {};
    }
  };

  const setSearchTerm = (value) => {
    dispatch({ type: "SET_LOADING", payload: { isLoading: false } });
    dispatchRa({ type: "SET_SEARCH_TERM", payload: value });

    // dispatch({type: "SET_SEARCH_INVENTORIES", payload: []});
    // setAisles([]);
    // setSelectedAisle(null);
  };

  const handleAisleChange = (aisleId) => {
    debugger;
    dispatch({ type: "SET_SEARCH_SELECTED_AISLE", payload: aisleId });
    if (aisleId) {
      const newInventories = dbInventories.filter((itm) =>
        itm.inventoryItems.items.find((invItm) => invItm.aisleId === aisleId),
      );
      dispatch({ type: "SET_SEARCH_INVENTORIES", payload: newInventories });
    } else {
      dispatch({ type: "SET_SEARCH_INVENTORIES", payload: dbInventories });
    }
  };

  const clearSearchResults = () => {
    dispatch({ type: "SET_SEARCH_INVENTORIES", payload: [] });
    dispatch({ type: "SET_DB_INVENTORIES", payload: [] });
    dispatch({ type: "SET_SEARCH_AISLES", payload: [] });
    dispatch({ type: "SET_SEARCH_SELECTED_AISLE", payload: "" });
    setNarrowSearchMsg("");
  };

  const clear = () => {
    dispatchRa({ type: "SET_SEARCH_TERM", payload: "" });
    dispatch({ type: "SET_INVENTORY_ITEM_SCANNED_BARCODE", payload: "" });
    clearSearchResults();
  };

  const handleAccountChange = async (newValue) => {
    clearSearchResults();
    if (newValue === null) {
      dispatchRa({ type: "SET_SELECTED_ACCOUNT", payload: NO_ACCOUNT });
      return;
    }
    dispatchRa({ type: "SET_SELECTED_ACCOUNT", payload: newValue });
  };

  const handleSubmit = (evt) => {
    if (evt.key === "Enter") {
      handleSearch(searchTerm, selectedSearchAisleId);
    }
  };

  const isSearchDisabled = () => {
    if (
      selectedAccount === NO_ACCOUNT &&
      !searchTerm &&
      !scannedBarcodes?.length
    )
      return true;
    // if (selectedAccount === NO_ACCOUNT || !searchTerm || searchTerm.length < 3) return true;
    return false;
  };

  const isAislesSearchAvailable = () => {
    return searchInventories?.length > 0 && !narrowSearchMsg;
  };

  return (
    <CrewCard title="Search Inventory" icon={<SearchIcon fontSize="large" />}>
      <Backdrop open={loading} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box mt={2} ml={1} mr={1}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Autocomplete
              id="accounts"
              fullWidth
              onChange={(event, newValue) => handleAccountChange(newValue)}
              value={selectedAccount}
              options={allAccounts}
              getOptionLabel={(option) => option.businessName}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Account"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              name="search"
              size="small"
              variant="outlined"
              onChange={(evt) => setSearchTerm(evt.target.value)}
              value={searchTerm}
              placeholder="Search"
              helperText={narrowSearchMsg}
              fullWidth
              required
              onKeyDown={handleSubmit}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton disableRipple onClick={clear}>
                      <XIcon className={classes.clearButton} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid spacing={2} xs={12} md={4}>
            <Box mt={1} ml={1} mr={1}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6}>
                  <Button
                    fullWidth
                    startIcon={<ScannerIcon />}
                    variant="contained"
                    onClick={handleScanButtonClick}
                  >
                    Scan
                  </Button>
                </Grid>
                <Grid item xs={6} md={6}>
                  <Button
                    color="primary"
                    fullWidth
                    variant="contained"
                    onClick={() =>
                      handleSearch(searchTerm, selectedSearchAisleId)
                    }
                    disabled={isSearchDisabled()}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {isAislesSearchAvailable() && (
            <Grid item xs={12} md={4}>
              <TextField
                id="aisles"
                size="small"
                variant="outlined"
                select
                label="Aisles"
                fullWidth
                value={selectedSearchAisleId}
                onChange={(e) => handleAisleChange(e.target.value)}
              >
                {searchAisles.map((itm) => (
                  <MenuItem key={itm.id} value={itm.id}>
                    <span className={classes.menuSelection}>
                      {itm.id ? getAisleFullName(itm) : ""}
                    </span>
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          {scanDialogOpen && (
            <RelocateBarcodeScan
              open={scanDialogOpen}
              onClose={handleScanClose}
              onSave={handleSaveBarcode}
              actionButtonText="Scan"
              barcodeList={scannedBarcodes}
              setBarcodeList={setScannedBarcodes}
            />
          )}
          <Grid container item xs={12} spacing={0} />
          {searchInventories &&
            searchInventories.map((inv) => (
              <InventorySearchCard
                key={inv.id}
                inventory={inv}
                match={match}
                history={history}
                scannedBarcodes={scannedBarcodes}
              />
            ))}
        </Grid>
      </Box>
    </CrewCard>
  );
};
